module.exports = __webpack_public_path__ + "img/pc-who-are-we-banner.38bb27c8.png";